var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"overlay"}},[_c('breeding-rhombus-spinner',{staticClass:"center",attrs:{"animation-duration":500,"size":65,"color":"#ff1d5e"}}),(_vm.showProgress)?_c('div',{staticClass:"center",staticStyle:{"top":"68%","left":"53%","width":"50%"}},[_c('span',{staticClass:"percentText"},[_vm._v(_vm._s(_vm.percentCompleted))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }